import { render, staticRenderFns } from "./Boletos.vue?vue&type=template&id=e9830bc8&"
import script from "./Boletos.vue?vue&type=script&lang=js&"
export * from "./Boletos.vue?vue&type=script&lang=js&"
import style0 from "./Boletos.vue?vue&type=style&index=0&id=e9830bc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports